(function () {
  'use strict';

  var GENERATOR_IMAGE = 'https://cdn.shopify.com/s/files/1/0649/1809/3911/files/Main_image.png?v=1762504205';
  var TIERS = [
    { max: 63, kw: '4.5', variant: '50510575993048' },
    { max: 83, kw: '6', variant: '50510576320728' },
    { max: 104, kw: '7.5', variant: '50510576648408' },
    { max: 140, kw: '9', variant: '50510576976088' },
    { max: 168, kw: '10.5', variant: '50510577303768' },
    { max: 200, kw: '12', variant: '50510577631448' }
  ];

  function firstTierFor(adjustedVolume) {
    for (var index = 0; index < TIERS.length; index += 1) {
      if (adjustedVolume <= TIERS[index].max) return TIERS[index];
    }
    return null;
  }

  function fieldNumber(form, name) {
    var field = form.querySelector('[name="' + name + '"]');
    return field ? parseFloat(field.value) : NaN;
  }

  function selectedMaterial(form) {
    var field = form.querySelector('[name="material"]:checked');
    return field ? parseFloat(field.value) : NaN;
  }

  function renderRecommendation(product, adjustedVolume, tier) {
    var roundedVolume = Math.round(adjustedVolume);

    if (!tier) {
      product.innerHTML = '<span class="ssd-sizing__result-kicker">Specialist sizing required · ' + roundedVolume + ' adjusted cu. ft.</span>' +
        '<h2>Your room needs a larger or dual-generator plan.</h2>' +
        '<p>The adjusted volume is above this calculator’s 12 kW ceiling. A specialist can confirm the correct equipment and control configuration.</p>' +
        '<ul><li>Complex-room review</li><li>Compatibility check</li><li>Installation guidance</li></ul>' +
        '<a class="ssd-button" href="tel:18664310913" data-no-instant>Call 1-866-431-0913 →</a>';
      return;
    }

    product.innerHTML = '<img src="' + GENERATOR_IMAGE + '" alt="SteamSpa Oasis steam generator">' +
      '<span class="ssd-sizing__result-kicker">Recommended output · ' + roundedVolume + ' adjusted cu. ft.</span>' +
      '<h2>' + tier.kw + ' kW Oasis QuickStart Generator</h2>' +
      '<p>This is the first output tier sized above your adjusted room volume. Confirm ceiling shape, glass area, and installation details before ordering.</p>' +
      '<ul><li>Continuous steam</li><li>Whisper quiet</li><li>Stainless-steel construction</li></ul>' +
      '<a class="ssd-button" href="/products/oat-prx?variant=' + tier.variant + '">View the ' + tier.kw + ' kW generator →</a>';
  }

  function initializeCalculator(root) {
    if (!root || root.getAttribute('data-sizing-ready') === 'true') return;

    var form = root.querySelector('[data-sizing-form]');
    var error = root.querySelector('[data-sizing-error]');
    var empty = root.querySelector('[data-sizing-empty]');
    var product = root.querySelector('[data-sizing-product]');
    if (!form || !error || !empty || !product) return;

    root.setAttribute('data-sizing-ready', 'true');

    var materials = form.querySelector('.ssd-sizing__materials');

    // Mark or clear the red state on the wrapper that draws the field border.
    function mark(field, invalid) {
      if (!field) return;
      var wrap = field.closest ? field.closest('.ssd-sizing__input') : null;
      if (wrap) wrap.classList.toggle('is-invalid', invalid);
      field.setAttribute('aria-invalid', invalid ? 'true' : 'false');
    }

    function clearAll() {
      ['length', 'width', 'height', 'walls'].forEach(function (name) {
        mark(form.querySelector('[name="' + name + '"]'), false);
      });
      if (materials) materials.classList.remove('is-invalid');
      error.hidden = true;
    }

    // Clearing as soon as the visitor corrects a field, so the red state never
    // lingers on something they have already fixed.
    form.addEventListener('input', function (event) {
      var field = event.target;
      if (field && field.name === 'material') {
        if (materials) materials.classList.remove('is-invalid');
        return;
      }
      mark(field, false);
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var length = fieldNumber(form, 'length');
      var width = fieldNumber(form, 'width');
      var height = fieldNumber(form, 'height');
      var material = selectedMaterial(form);
      var walls = fieldNumber(form, 'walls');

      clearAll();

      var invalid = [];
      [['length', length], ['width', width], ['height', height]].forEach(function (pair) {
        var field = form.querySelector('[name="' + pair[0] + '"]');
        if (!(isFinite(pair[1]) && pair[1] > 0)) {
          mark(field, true);
          invalid.push((field && field.getAttribute('data-label')) || pair[0]);
        }
      });

      var wallsField = form.querySelector('[name="walls"]');
      var wallsAreValid = isFinite(walls) && walls >= 0 && walls <= 4 && Math.floor(walls) === walls;
      if (!wallsAreValid) {
        mark(wallsField, true);
        invalid.push((wallsField && wallsField.getAttribute('data-label')) || 'Exterior walls');
      }

      if (!isFinite(material)) {
        if (materials) materials.classList.add('is-invalid');
        invalid.push('Main surface material');
      }

      if (invalid.length) {
        var list = invalid.length === 1
          ? invalid[0]
          : invalid.slice(0, -1).join(', ') + ' and ' + invalid[invalid.length - 1];
        var wallsBad = invalid.indexOf('Exterior walls') > -1;
        if (invalid.length === 1 && wallsBad) {
          error.innerHTML = 'Enter a whole number from 0 to 4 for <b>Exterior walls</b>.';
        } else if (invalid.length === 1) {
          error.innerHTML = 'Please complete <b>' + list + '</b>.';
        } else {
          error.innerHTML = 'Please complete the highlighted fields: <b>' + list + '</b>.' +
            (wallsBad ? ' Exterior walls must be a whole number from 0 to 4.' : '');
        }
        error.hidden = false;

        // Send the visitor straight to the first thing that needs attention.
        var firstBad = form.querySelector('[aria-invalid="true"]') ||
                       form.querySelector('.ssd-sizing__materials.is-invalid input');
        if (firstBad) {
          if (firstBad.scrollIntoView) firstBad.scrollIntoView({ behavior: 'smooth', block: 'center' });
          if (firstBad.focus) firstBad.focus({ preventScroll: true });
        }
        return;
      }

      error.hidden = true;
      var adjustedVolume = length * width * height * material * (1 + (0.10 * walls));
      renderRecommendation(product, adjustedVolume, firstTierFor(adjustedVolume));
      empty.hidden = true;
      empty.style.display = 'none';
      product.hidden = false;
      product.style.display = 'flex';

      if (window.matchMedia && window.matchMedia('(max-width: 950px)').matches) {
        product.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  function initializeAll(scope) {
    var calculators = (scope || document).querySelectorAll('[data-ssd-sizing]');
    for (var index = 0; index < calculators.length; index += 1) {
      initializeCalculator(calculators[index]);
    }
  }

  function start() {
    initializeAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
